module.exports = __webpack_public_path__ + "img/safe_move04.fa3b4c62.png";